<template>
  <v-row shrink>
    <v-flex shrink px-1 py-1>
      <BookingDateInput
        @input="function() {bookingForm.updateDate(); lastTime = null;}"
        label="Date"
        v-model="bookingForm.booking.pickup_date"
        :error="bookingForm.errors.pickup_time"
      />
    </v-flex>
    <v-flex py-1 px-1 pr-2 shrink>
      <SimpleTextInput
        @blur="function() {bookingForm.updateDate(); lastTime = null;}"
        label="Time"
        v-mask="mask"
        v-model="bookingForm.booking.pickup_time"
        width="65px"
      ></SimpleTextInput>
    </v-flex>
    <v-flex pt-2 v-if="!hideAsapToggle">
      <v-row>
        <div
          class="now-toggle left"
          v-bind:style="colorForAsapButton()"
          @click="function() {bookingForm.toggleAsap(); lastTime = 0;}"
        >
          <p class="centered-p">Now</p>
        </div>
        <div
          v-bind:style="{ 'backgroundColor': lastTime == 15 ? 'lightgreen' : 'lightgrey'  }"
          class="future-toggle"
          @click="function() {bookingForm.setPickupTimeAhead(15); lastTime = 15;}"
        >
          <p class="centered-p">15</p>
        </div>
        <div
          v-bind:style="{ 'backgroundColor': lastTime == 30 ? 'lightgreen' : 'lightgrey'  }"
          class="future-toggle right"
          @click="function() {bookingForm.setPickupTimeAhead(30); lastTime = 30;}"
        >
          <p class="centered-p">30</p>
        </div>
      </v-row>
    </v-flex>
  </v-row>
</template>

<script>
import BookingDateInput from "@/components/widget/input/BookingDateInput.vue";
import SimpleTextInput from "@/components/widget/input/SimpleTextInput.vue";

import { mask } from "vue-the-mask";

export default {
  name: "BookingDateTimeInput",
  directives: {
    mask
  },
  model: {
    prop: "content",
    event: "input"
  },
  components: {
    BookingDateInput,
    SimpleTextInput
  },
  props: {
    content: String,
    label: String,
    required: Boolean,
    errorMessages: Object,
    bookingForm: Object,
    hideAsapToggle: {
      type: Boolean,
      default: false
    }
  },
  computed: {},
  data() {
    return {
      mask: "##:##",
      menu: false,
      lastTime: null
    };
  },
  methods: {
    colorForAsapButton: function() {
      console.log("Booking form asap " + this.bookingForm.booking.asap);
      return {
        backgroundColor: this.bookingForm.booking.asap
          ? "lightgreen"
          : "lightgrey"
      };
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.now-toggle {
  cursor: pointer;
  padding-left: 6px;
  padding-right: 6px;
  height: 24px;
  width: 36px;
  font-size: 11px;
  text-align: center;
}

.future-toggle {
  cursor: pointer;
  background-color: lightgray;
  padding-left: 6px;
  padding-right: 6px;
  height: 24px;
  width: 26px;
  font-size: 11px;
  text-align: center;
}

.left {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

.right {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}

.centered-p {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
</style>
